module.exports = __webpack_public_path__ + "img/momo_title_point_record.6cd20baf.png";